import { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import Modal from "@weave-design/modal";
import { ModelTranslationStatus } from "../../../../../responses/linkedModel";
import { ProcessingPane } from "../../../../processing-pane/processingPane";
import { rootElement } from "../../../../shared";
import { WeaveDesignStylesheet } from "../../../../sharedTypes";
import { LinkedModelCard } from "./linkedModelCard";
import { LinkedModelView } from "../../../eventBus/linkedModelsEventPayloads";
import repo from "../../../../../Repository";

type Props = {
    projectId: string;
    selectModel: (model: LinkedModelView) => void | Promise<void>;
    close: () => void;
};

export const PrimaryModelsList = ({ projectId, selectModel, close }: Props) => {
    const [loading, setLoading] = useState(true);
    const [models, setModels] = useState<LinkedModelView[]>([]);

    const load = async () => {
        const primaryModelsResponse = await repo.findProjectPrimaryLinkedModels(projectId);

        setLoading(false);

        if (primaryModelsResponse.isSuccess) {
            setModels(
                primaryModelsResponse.items.map(x => ({
                    ...x,
                    isVisible: true,
                    isLoaded: x.status === ModelTranslationStatus.Ready,
                })),
            );
        } else {
            close();
        }
    };

    useEffect(() => {
        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return ReactDOM.createPortal(
        <>
            {loading ? (
                <ProcessingPane isVisible message="Retrieving project linked models..." title="Loading..." />
            ) : (
                <Modal open title="Models" onCloseClick={close} stylesheet={modalStyles}>
                    <div className="linked-model-list">
                        {models.map(model => (
                            <LinkedModelCard
                                key={model.id}
                                model={model}
                                controlsEnabled={false}
                                onSelect={selectModel}
                            />
                        ))}
                    </div>
                </Modal>
            )}
        </>,
        rootElement,
    );
};

const modalStyles = (styles: WeaveDesignStylesheet) => ({
    ...styles,
    modal: {
        ...styles.modal,
        window: {
            ...styles.modal.window,
            width: "360px",
            height: "460px",
        },
        bodyContent: {
            ...styles.modal.bodyContent,
            padding: 8,
        },
    },
});
